
import { IId } from './util';
import { IApiGetLocation, LocationId } from './location';

interface IApiPlaylistBase {
  bookings: number[];
}

export interface IApiSetPlaylist extends IApiPlaylistBase {
  location: number;
}

export interface IApiGetPlaylist extends IApiPlaylistBase, IId {
  location: IApiGetLocation;
}

export enum PlaylistType {
  shuffle = 'shuffle',
  custom = 'custom',
}

export type PlaylistId = IId['id'];

export interface IPlaylistAttributes {
  id: PlaylistId;
  bookings: string | Array<number>;
  location: LocationId;
}
